import { PlatformService } from "../resource";
import swal from "sweetalert2";

const PlatformModule = {
    namespaced: true,
    state: {
        datum: {},
		sellers: [],


    },
    mutations: {
		SET_SELLER(state, data) {
			state.sellers = data;
		  },
    },
    actions: {
		
		
		RefreshToken({ commit, state }, params) {
			return PlatformService.RefreshToken(params);
		},
		SyncProduct({ commit, state }, params) {
			return PlatformService.SyncProduct(params);
		},
		SyncOrder({ commit, state }, params) {
			return PlatformService.SyncOrder(params);
		},
		SyncProductV2({ commit, state }, params) {
			return PlatformService.SyncProductV2(params);
		},
		SyncOrderV2({ commit, state }, params) {
			return PlatformService.SyncOrderV2(params);
		},
		ConnectPlatform({ commit, state }, params) {
			return PlatformService.ConnectPlatform(params);
		},
		async listSeller({ commit, state },params) {
			try {
			  const data = await PlatformService.ListSeller(params);
			  if (data.data.Data == null) {
				commit("SET_SELLER", []);
			  } else {
				commit("SET_SELLER", data.data.Data);
			  }
			} catch (err) {
			  commit("SET_SELLER", []);
			}
		  },

    },
    getters: {
		getSellers(state){
			return state.sellers
		}
    }
};

export default PlatformModule;
